module.exports = __webpack_public_path__ + "img/Filters-lines.df6db7f3.svg";